function contactForm (container = document) {
  // console.log(container)

  const form = container.querySelector('#contact-form')

  if (form) {
    const apiKey = 'tiHiE1W3BOIZv953j46jWKn8NeYwv0zRr' // Submit 1.0
    const ajaxUrl = 'https://gbstpetersburg.com/submit/send.php'
    // const emailTarget = 'gbstpetersburg@gmail.com'
    const emailTarget = 'nicolook.pro@gmail.com'
    // const emailTarget2  = 'example@example.com' 
    // const emailTarget3  = 'example@example.com' 
    const fromName = 'GRACIE BARRA St. Petersburg'
    const subject = 'Request from Gracie Barra St. Petersburg Website'

    let notices

    const protocolo = window.location.protocol
    const dominio = window.location.hostname
    const baseURL = protocolo + '//' + dominio

    const result = container.querySelector('#result')

    // const lang = form.querySelector('[name=lang]')
    const name = form.querySelector('[name=name]')
    const email = form.querySelector('[name=email]')
    // const phone = form.querySelector('[name=phone]')
    const message = form.querySelector('[name=message]')
    const btnSubmit = form.querySelector('[type=submit]')

    const nameRegex = /^[A-Za-zÁÉÍÓÚáéíóúÜüÑñ]+ [A-Za-zÁÉÍÓÚáéíóúÜüÑñ]+$/
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    const phoneRegex = /^(?:\+[1-9]\d{6,14}|\d{7,15})$/
    const messageRegex = /^.{16,}$/ // min 16 caracteres

    /* /////////////////// FROM & SUBJECT //////////////////// */
    function formatDateTime () {
      const now = new Date()

      const day = String(now.getDate()).padStart(2, '0')
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const year = now.getFullYear()

      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')

      return `${day}-${month}-${year} | ${hours}:${minutes} hs`
    }

    /* ///////////////////// NOTICES /////////////////////// */

      notices = {
        success: 'Thank you for contacting us. We will get back to you shortly.',
        error: 'Error. Please try again.'
      }

    /* ////////////////// TEMPORIZADORES /////////////////// */
    // Definir una variable para el temporizador de retraso
    let typingTimer

    // Tiempo de espera en milisegundos antes de ejecutar la validación
    const doneTypingInterval = 500 // 500 milisegundos (0.5 segundos)

    // Función para manejar el evento de entrada en el campo
    function handleInput (field, regex) {
      // Limpiar el temporizador existente
      clearTimeout(typingTimer)

      // Comenzar un nuevo temporizador
      typingTimer = setTimeout(function () {
        // Ejecutar la validación después del tiempo de espera
        validField(field, regex)
      }, doneTypingInterval)
    }

    /* ////////////////// VALIDAR /////////////////// */

    function validField (field, regex) {
      const field_val = field.value
      // console.log(field_val);

      if (!field_val.match(regex)) {
        field.classList.add('invalid')
        return false
      }

      field.classList.remove('invalid')
      return true
    }

    /* ////////////////// CHECK FORM /////////////////// */
    function checkForm () {
      let formStatus = ''

      if (validField(name, nameRegex) && validField(email, emailRegex) && validField(message, messageRegex)) {
        btnSubmit.disabled = false
        formStatus = true
      } else {
        btnSubmit.disabled = true
        formStatus = false
      }

      return formStatus
    }

    /* ////////////////// EVENT HANDLING /////////////////// */

    name.addEventListener('input', function () {
      handleInput(name, nameRegex)
    })

    email.addEventListener('input', function () {
      handleInput(email, emailRegex)
    })

    // phone.addEventListener('input', function () {
    //   handleInput(phone, phoneRegex)
    // })

    message.addEventListener('input', function () {
      handleInput(message, messageRegex)
    })

    form.onchange = () => {
      checkForm()
    }

    // message.addEventListener('mouseleave', function () {
    //   checkForm()
    // })

    /* ////////////////// SUBMIT /////////////////// */

    form.addEventListener('submit', async (e) => {
      e.preventDefault()
      const loader = container.querySelector('.loader')
      if (loader) loader.style.display = 'block'

      if (checkForm()) {
        // Crear FormData y agregar campos obligatorios
        const formData = new FormData(form)
        formData.append('api_key', apiKey)

        formData.append('email_target', emailTarget)

        // if ( emailTarget2 ) {
        //   formData.append('email_target2', emailTarget2)
        // }

        // if ( emailTarget3 ) {
        //   formData.append('email_target3', emailTarget3)
        // }

        formData.append('from_name', fromName)
        formData.append('subject', subject)

        try {
          const response = await fetch(ajaxUrl, {
            method: 'POST',
            body: formData // No agregues headers, el navegador gestiona el Content-Type
          })
          const json = await response.json()

          if (response.status === 200) {
            if (loader) loader.style.display = 'none'
            if (result) {
              result.innerHTML = notices.success
              result.style.display = 'block'
              result.classList.add('active')
            }
          } else {
            if (result) {
              result.innerHTML = json.message || notices.error
              result.style.display = 'block'
              result.classList.add('active')
            }
          }
        } catch (error) {
          if (result) {
            result.innerHTML = notices.error
            result.style.display = 'block'
            result.classList.add('active')
          }
        } finally {
          form.reset()
          setTimeout(() => {
            if (result) result.style.display = 'none'
            result.classList.remove('active')
          }, 3000)
        }
      }
    })
  } // if contact from
}

export default contactForm
